var render = function render() {
        var _vm = this,
            _c = _vm._self._c;return _c('div', { key: _vm.keyPath, staticClass: "v3-game-difficulty" }, [_c('v3-game-difficulty-instance', { key: _vm.keyPath, attrs: { "key-path": _vm.keyPath, "prefix": _vm.prefix, "game-config": _vm.gameConfig, "play-config": _vm.playConfig }, on: { "change": _vm.handleChange, "add-validator": function addValidator(validate) {
                                _vm.$emit('add-validator', validate);
                        } } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };